angular.module('rjmNg.directives').directive "updateInfo", [
  "$http"
  "$templateCache"
  "$compile"
  ($http, $templateCache, $compile) ->
    templateLoader = null

    restrict: "E"
    templateUrl: "directive.updateInfo.html"
    replace: true
    scope:
      showtimezone: '='
      template: "@"
    compile: (tElement, tAttrs, transclude) ->
      #Use a custom template if one is provided
      if tAttrs.template?
        return (scope, element, attrs) ->
          #first wait for the template attribute to be evaluated
          attrs.$observe "template", (value) ->
            #Go and fetch the template
            templateLoader = $http.get(value, {cache: $templateCache})
              .then ({data}) ->
                tElement.html(data)
            #Assign the template to the directive
            templateLoader.then (templateText) ->
              element.html($compile(tElement.html())(scope))
    controller: [
      "$scope"
      "updateService"
      "app"
      "dateService"
      "$q"
      "jobService"
      "emailNotificationService"
      "email"
      "$timeout"
      "notification"
      ($scope, updateService, app, dateService, $q, jobService, emailNotificationService, email, $timeout, notification) ->

        # Example usage:  <update-info></update-info>

        userId = app.getUserId()
        clientId = app.getClientId()
        $scope.isLoading = 'blocked loading'
        $scope.dateService = dateService
        $scope.updateInfo = null
        $scope.isCurrentUpdateQueued = false
        $scope.isCheckingJobStatus = true

        $scope.startUpdateStatusPoll = ->
          updateService.get(clientId)
          .then( (response) ->
            # We got a response, update the state
            $scope.isCurrentUpdateQueued  = false
            $scope.isCheckingJobStatus    = false
            $scope.updateInfo             = response
            $scope.updateUpToDateThrough  = updateService.getCompletedUpdateUpToDateThrough response
            $scope.dataUpToDateThrough    = updateService.getDataUpToDateThrough response
            $scope.currentUpdateStatus    = updateService.getCurrentUpdateLength response
            $scope.isCurrentUpdateRunning = updateService.isCurrentUpdateRunning response
            $scope.isLoading              = ''

            if $scope.isCurrentUpdateRunning
              $timeout ->
                $scope.startUpdateStatusPoll()
              , 30000
          )

        $scope.sendEmailWhenUpdateCompletes = () ->
          emailNotificationService.post(email.TYPE.FULL_UPDATE_COMPLETION)
          notification.success null, "You will receive an email when the update is complete.", "global"
          $scope.alert = "You will receive an email when the update is complete."

        $scope.queueFullUpdate = () ->
          $scope.isCurrentUpdateQueued = true
          fullUpdateJob = 2 #JobType::FULL_UPDATE
          jobService(fullUpdateJob).queue(
            {isForced : 1},
            () ->
              $scope.alert = "Update queued successfully!"
              $timeout ->
                $scope.startUpdateStatusPoll()
              , 5000
            ,
            () ->
              $scope.isCurrentUpdateQueued = false
              $scope.alert = "An error occurred when queuing the update. If this error persists, please contact support."
          )

        $scope.startUpdateStatusPoll()
    ]
]
